import {
  Align,
  Button,
  Loader,
  Spacer,
  SvgArrowRightAlt,
  Text,
} from '@loomhq/lens';
import React, { useEffect, useState } from 'react';

import { COMPLETED_ONBOARDING_STEP } from 'constants/events';
import { ANON_RECORD_A_REPLY } from 'constants/onboarding';
import * as analytics from 'utilities/analytics';
import { incrementMetric } from 'utilities/metrics';
import {
  getSuggestedWorkspacesQuery,
  requestToJoinWorkspace,
} from 'utilities/welcome';

import connectWithTeamImg from '../assets/connect_with_team.svg';

import { WorkspaceList } from 'components/welcome-webapp-simplified/steps/suggested-workspaces-step';

const ShareSuggestedWorkspaces = ({ nextClickHandler, currentStep }) => {
  const [workspaces, setWorkspaces] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getSuggestedWorkspaces() {
      const { data } = await getSuggestedWorkspacesQuery();

      if (!data?.result?.workspaces?.length) {
        analytics.track(COMPLETED_ONBOARDING_STEP, {
          step: currentStep,
          action: 'no suggestions',
          source: ANON_RECORD_A_REPLY,
        });

        incrementMetric('button.click', {
          context: COMPLETED_ONBOARDING_STEP,
          step: currentStep,
          action: 'no-suggestions',
          source: ANON_RECORD_A_REPLY,
        });

        nextClickHandler();
      }

      setWorkspaces(data);
      setLoading(false);
    }

    getSuggestedWorkspaces();
  }, [currentStep, nextClickHandler]);

  async function onRequestClick(workspaceId) {
    const {
      data: { result },
    } = await requestToJoinWorkspace(workspaceId);

    analytics.track(COMPLETED_ONBOARDING_STEP, {
      step: currentStep,
      organization_id: workspaceId,
      action: result.status,
      source: ANON_RECORD_A_REPLY,
    });

    incrementMetric('button.click', {
      context: COMPLETED_ONBOARDING_STEP,
      step: currentStep,
      action: result.status,
      source: ANON_RECORD_A_REPLY,
    });

    nextClickHandler();
  }

  function skip() {
    analytics.track(COMPLETED_ONBOARDING_STEP, {
      step: currentStep,
      action: 'skipped',
      source: ANON_RECORD_A_REPLY,
    });

    incrementMetric('button.click', {
      context: COMPLETED_ONBOARDING_STEP,
      step: currentStep,
      action: 'skipped',
      source: ANON_RECORD_A_REPLY,
    });

    nextClickHandler();
  }

  if (!workspaces || loading) {
    return (
      <Align alignment="center">
        <Loader size="large" />
      </Align>
    );
  }

  return (
    <>
      <div className="text:center">
        <img src={connectWithTeamImg} width="110" height="110" />
      </div>
      <Spacer top={2} bottom={1}>
        <Text size="xlarge" fontWeight="bold">
          We found your team on Loom!
        </Text>
      </Spacer>
      <Text size="medium">
        Join your team’s Workspace and gain instant access to team videos and
        see deeper video insights.
      </Text>

      <Spacer top={1} bottom={4}>
        <WorkspaceList
          workspaces={workspaces.result.workspaces}
          onRequestClick={onRequestClick}
          onSkip={skip}
          isMobile={false}
        />
      </Spacer>

      <div className="text:right">
        <Button
          variant="neutral"
          icon={<SvgArrowRightAlt />}
          iconPosition="right"
          onClick={nextClickHandler}
        >
          Create a new Workspace
        </Button>
      </div>
    </>
  );
};

export default ShareSuggestedWorkspaces;
